export const momentTypes = [
	{
		name: 'MORNING',
		value: 'Mañana',
	},
	{
		name: 'EVENING',
		value: 'Tarde',
	},
	{
		name: 'ALL_DAY',
		value: 'Todo el día',
	},
];
